import { create } from "zustand";

export type SessionInvalidReasonType =
  | "license_limit"
  | "concurrent_login"
  | "permission_error"
  | "unknown";

export interface SessionInvalidReason {
  type: SessionInvalidReasonType;
  message: string;
}

interface SessionState {
  sessionExpired: boolean;
  expiredReason: SessionInvalidReason | null;
  triggerExpired: (reason: SessionInvalidReason) => void;
  reset: () => void;
}

/**
 * Shared state for the "session expired" overlay. Mirrors the reactive
 * refs from Vue's `useSessionValidation` composable so any module
 * (httpClient interceptor, cookie monitor) can flip the flag and the
 * SessionExpiredModal — mounted in MainLayout — will react.
 */
export const useSessionStore = create<SessionState>((set) => ({
  sessionExpired: false,
  expiredReason: null,
  triggerExpired: (reason) =>
    set({ sessionExpired: true, expiredReason: reason }),
  reset: () => set({ sessionExpired: false, expiredReason: null }),
}));

export const selectSessionExpired = (s: SessionState) => s.sessionExpired;
export const selectExpiredReason = (s: SessionState) => s.expiredReason;
